import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function useIsAdmin() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const check = async (userId: string | undefined) => {
      if (!userId) {
        if (!cancelled) { setIsAdmin(false); setLoading(false); }
        return;
      }
      try {
        const [{ data: profile }, { data: adminUser }] = await Promise.all([
          supabase.from('profiles').select('role').eq('id', userId).maybeSingle(),
          supabase.from('admin_users').select('is_super_admin').eq('user_id', userId).maybeSingle(),
        ]);
        if (!cancelled) {
          // Grant access if: profile.role is admin, OR user exists in admin_users (any level)
          setIsAdmin(profile?.role === 'admin' || !!adminUser);
          setLoading(false);
        }
      } catch {
        if (!cancelled) { setIsAdmin(false); setLoading(false); }
      }
    };

    supabase.auth.getUser().then(({ data }) => check(data.user?.id));
    const { data: sub } = supabase.auth.onAuthStateChange((_e, session) => {
      check(session?.user?.id);
    });
    return () => { cancelled = true; sub.subscription.unsubscribe(); };
  }, []);

  return { isAdmin, loading };
}